import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "originalForm", "refreshRequestForm" ]

  submit(event) {
    const formData = new FormData(this.originalFormTarget)
    formData.delete("_method")
    formData.delete("authenticity_token")

    for (const [key, value] of formData.entries()) {
      const refresh_key = "refresh_" + key
      const input = this.refreshRequestFormTarget.querySelector(`input[name="${refresh_key}"]`)
      if (input) {
        input.value = value;
      }
    }
    this.refreshRequestFormTarget.requestSubmit()
  }
}
